module.exports = __webpack_public_path__ + "static/nbpl-logo-310fc0f496c14426f05f4179c87330a0.jpg";